import "../styles/Terms.css";

export default function Terms() {
  return (
    <div className="terms-page">
      <section className="terms-hero">
        <div className="terms-hero-bg">
          <span className="orb orb-a"></span>
          <span className="orb orb-b"></span>
          <span className="orb orb-c"></span>
        </div>
        <div className="terms-hero-inner">
          <h1 className="terms-hero-title">Terms & Conditions</h1>
          <p className="terms-hero-text">
            These terms outline the rules, policies, and agreements that apply
            when you engage with DeClerck’s Goldens — from browsing our site, to
            reserving a puppy, to using our stud services. Please read carefully
            and reach out if you have any questions.
          </p>
        </div>
      </section>

      <section className="terms-content">
        <article>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing this website, contacting us, or making a reservation,
            you agree to be bound by these Terms & Conditions as well as our
            Privacy Policy. If you do not agree, please discontinue use of the
            site and our services.
          </p>
        </article>

        <article>
          <h2>2. Puppy Reservations & Deposits</h2>
          <p>
            Puppies cannot be held without a deposit. Deposits are non-refundable
            but may be transferable to a future litter at our discretion. Full
            payment is due before a puppy leaves our care.
          </p>
        </article>

        <article>
          <h2>3. Health Guarantee</h2>
          <p>
            Every puppy is sold with a veterinarian health check and
            age-appropriate vaccinations. Details of the health guarantee and
            buyer responsibilities are outlined in your purchase contract.
          </p>
        </article>

        <article>
          <h2>4. Stud Services</h2>
          <p>
            All stud services require signed agreements. Live, shipped, and
            collected semen services are subject to availability. Fees must be
            paid in full prior to service.
          </p>
        </article>

        <article>
          <h2>5. Limitation of Liability</h2>
          <p>
            While we provide puppies and stud services in good faith, we are not
            liable for issues that arise after transfer of ownership, except as
            covered in the health guarantee or stud contract.
          </p>
        </article>

        <article>
          <h2>6. Use of Website</h2>
          <p>
            Content on this site, including text, photos, and branding, is
            protected intellectual property. You may not copy or distribute
            without prior written consent.
          </p>
        </article>

        <article>
          <h2>7. Governing Law</h2>
          <p>
            These Terms & Conditions are governed by the laws of New York State.
            Any disputes will be resolved in accordance with state and federal
            regulations.
          </p>
        </article>

        <div className="terms-footer-note">
          <p>
            Questions? We’re here to help. Please{" "}
            <a href="/contact">contact us</a> before making a reservation or
            entering into a contract.
          </p>
        </div>
      </section>
    </div>
  );
}